import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import { showOverlay, hideOverlay, scrollToFirstError } from '../services/form_helper'

export default class extends Controller {
  static targets = ["modal", 'form','clinicalDepartmentDetail','clinicalDetailSelect','serviceTypeSelect','dateSelect','selectedDate','modalClose', 'modalSelected','selectDateTable','notSelectDate'];
  static classes = ["open", 'errorm','hide','selected','readonly'];
  static values = {validateurl: String, clinicalviewurl: String, prompt: String, dateselecturl: String, modalerrormessage: String, uploadurl: String, removeimageurl: String, notselectmessage: String, scheduleType: String};

  connect() {
    const dep = document.getElementById("reservation_clinical_department_id");
    if(dep.value != null && this.dateSelectTargets.length > 0){
      this.dateSelect(null,dep);
    }
  }
  formTargetConnected(){
    const corpMailType = this.formTarget.querySelector("input[name='user[email_type]']");
    if (corpMailType != undefined){
      this.readonlyUserEmail(corpMailType);
    }
  }

  dateModal(event) {
    if(this.hasModalTarget){
      this.modalTarget.classList.toggle(this.openClass);
    }else {
      const el = event.currentTarget;
      const pa = el.parentElement;
      let errorM = pa.querySelector("."+this.errormClass);
      if(errorM == undefined){
        errorM = pa.parentElement.querySelector("."+this.errormClass);
      }
      errorM.innerHTML = this.modalerrormessageValue;
    }
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  clinicalView(event){
    const el = event.currentTarget;
    if(el.value != null && el.value != ""){
      Rails.ajax({
        url: this.clinicalviewurlValue,
        type: "GET",
        dataType: 'json',
        data: "clinical="+el.value,
        success: (response)=> {
          if(response.clinical_detail.length > 0){
            let cd_options = "<option value=''>"+this.promptValue+"</option>";
            response.clinical_detail.forEach(function (cd) {
              cd_options += "<option value='"+cd.id+"'>"+cd.name+"</option>";
            });
            this.clinicalDetailSelectTarget.innerHTML = cd_options;
            this.clinicalDepartmentDetailTarget.classList.remove(this.hideClass);
          }else{
            this.clinicalDetailSelectTarget.selectedIndex = -1;
            this.clinicalDepartmentDetailTarget.classList.add(this.hideClass);
          }
          if(response.service_type.length > 0){
            let st_options = "<option value=''>"+this.promptValue+"</option>";
            response.service_type.forEach(function (cd) {
              st_options += "<option value='"+cd.id+"'>"+cd.name+"</option>";
            });
            this.serviceTypeSelectTarget.innerHTML = st_options;
          }
        }
      });
    }
  }

  dateSelect(event,element=null){
    let el;
    if(element != null){
      el = element;
    }else{
      el = event.currentTarget;
    }
    if(el.value != null && el.value != ""){
      Rails.ajax({
        url: this.dateselecturlValue,
        type: "GET",
        dataType: 'html',
        data: "clinical=" + el.value + "&schedule_type=" + this.scheduleTypeValue,
        success: (response) => {
          this.dateSelectTarget.textContent = "";
          this.dateSelectTarget.appendChild(response.getElementById("date_select_modal"));
          const tentative = document.getElementById("reservation_time_tentative");
          const temp_flag = document.getElementById("temp_flag");
          if(tentative.value == "true"){
            temp_flag.checked = true;
            this.selectDateTableTarget.classList.add(this.hideClass);
            this.notSelectDateTarget.classList.remove(this.hideClass);
            this.modalCloseTarget.classList.add(this.hideClass);
            this.modalSelectedTarget.classList.remove(this.hideClass);
          }
        }
      });
    }
  }

  dateSelected(event){
    event.preventDefault();
    const el = event.currentTarget;
    const params = event.params;

    const selecteds = document.querySelectorAll("."+this.selectedClass);
    for(let i=0;selecteds.length > i;i++){
      selecteds[i].classList.remove(this.selectedClass);
    }
    el.parentElement.classList.add(this.selectedClass);

    this.modalCloseTarget.classList.add(this.hideClass);
    this.modalSelectedTarget.classList.remove(this.hideClass);

    this.selectedDateTarget.innerHTML = params.datetime;
    document.getElementById("reservation_time_year").value = params.year;
    document.getElementById("reservation_time_month").value = params.month;
    document.getElementById("reservation_time_day").value = params.day;
    document.getElementById("reservation_time_time").value = params.time;
    document.getElementById("reservation_time_error_message").textContent = "";
  }
  /** リファクタリングにより不要になったためコメントアウト。そのうち削除
  addUploadField(){
    if(this.add1ImageTarget.classList.contains(this.hideClass) == false && this.add2ImageTarget.classList.contains(this.hideClass)){
      this.add2ImageTarget.classList.remove(this.hideClass);
    }
    if(this.add1ImageTarget.classList.contains(this.hideClass)){
      this.add1ImageTarget.classList.remove(this.hideClass);
    }
  }

  autoUpload(event){
    const el = event.currentTarget;
    const params = event.params;
    const targetName = params.targetname;
    if(el.value != null && el.value != ""){
      const formData = new FormData(this.formTarget);
      formData.append("type",targetName);
      Rails.ajax({
        url: this.uploadurlValue,
        type: "POST",
        dataType: 'json',
        data: formData,
        success: (response) => {
          if(response.error != null){
            document.getElementById("insurance_cards_"+targetName+"_error_message").textContent = response.error;
          }else{
            const viewDiv = document.getElementById("image_view_"+targetName);
            const image = viewDiv.querySelector("img");
            image.src = response.image_url;
            viewDiv.classList.remove(this.hideClass);
            document.getElementById("image_upload_"+targetName).classList.add(this.hideClass);
            document.getElementById("insurance_cards_id").value = response.ic_id;
            document.getElementById("insurance_cards_"+targetName+"_error_message").textContent = "";
          }
        }
      });
    }
  }

  removeImage(event){
    const params = event.params;
    const targetName = params.targetname;
    const formData = new FormData(this.formTarget);
    formData.append("type",targetName);
    Rails.ajax({
      url: this.removeimageurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        console.log(response);
        const viewDiv = document.getElementById("image_view_"+targetName);
        const image = viewDiv.querySelector("img");
        image.src = "";
        viewDiv.classList.add(this.hideClass);
        document.getElementById("image_upload_"+targetName).classList.remove(this.hideClass);
      }
    });
  }
  **/
  validateAll(){
    showOverlay();
    let errorMs = document.querySelectorAll("."+this.errormClass);
    const formData = new FormData(this.formTarget);
    const allErrorE = document.getElementById("allError");
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        if(Object.keys(response).length > 0){
          let allErrorTxt = "";
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
                allErrorTxt += response[key]+"<br />";
              }
            })
          });
          //メールアドレス登録を必須にしたので、このエラーは表示しなくなったので、一旦コメントアウト
          //if(!Object.keys(response).includes('no_contact')){
          //  Array.from(errorMs).find(m => m.dataset.errormtarget == 'no_contact').innerHTML = '';
          //}
          allErrorE.innerHTML = allErrorTxt;
          allErrorE.classList.remove(this.hideClass);
          hideOverlay();
          scrollToFirstError(this.errormClass);
        }else{
          allErrorE.innerHTML = '';
          allErrorE.classList.add(this.hideClass);
          this.formTarget.submit();
        }
      }
    });
  }

  corpMail(e){
    const el = e.currentTarget;
    this.readonlyUserEmail(el);
  }
  readonlyUserEmail(el){
    const userMail = this.formTarget.querySelector("#user_email");
    if(el.value == "1" || el.value == "3"){
      userMail.classList.add(this.readonlyClass);
      userMail.readOnly = true;
    }else{
      userMail.classList.remove(this.readonlyClass);
      userMail.readOnly = false;
    }
  }

  dateNotSelect(e){
    const el = e.currentTarget;
    this.selectDateTableTarget.classList.toggle(this.hideClass);
    this.notSelectDateTarget.classList.toggle(this.hideClass);
    if(el.checked){
      const selecteds = document.querySelectorAll("."+this.selectedClass);
      for(let i=0;selecteds.length > i;i++){
        selecteds[i].classList.remove(this.selectedClass);
      }
      this.selectedDateTarget.innerHTML = this.notselectmessageValue;
      document.getElementById("reservation_time_year").value = null;
      document.getElementById("reservation_time_month").value = null;
      document.getElementById("reservation_time_day").value = null;
      document.getElementById("reservation_time_time").value = null;
      document.getElementById("reservation_time_tentative").value = "true";
      this.modalCloseTarget.classList.add(this.hideClass);
      this.modalSelectedTarget.classList.remove(this.hideClass);
    }else{
      document.getElementById("reservation_time_tentative").value = "false";
      this.modalCloseTarget.classList.remove(this.hideClass);
      this.modalSelectedTarget.classList.add(this.hideClass);
    }
  }
}
